// extracted by mini-css-extract-plugin
module.exports = {"swiss_medical_arcos__redText":"SwissMedicalArcos_swiss_medical_arcos__redText__2pd9j","swiss_medical_arcos__image":"SwissMedicalArcos_swiss_medical_arcos__image__3sOfL"};